import { render, staticRenderFns } from "./MedicineBtns.vue?vue&type=template&id=21a04e34&"
import script from "./MedicineBtns.vue?vue&type=script&lang=js&"
export * from "./MedicineBtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports